exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".r-higher-logic{isolation:isolate}.r-higher-logic .st0{fill:#75767a}.r-higher-logic .st1{fill:url(#SVGID_1_)}.r-higher-logic .stop0{stop-color:#ef833c}.r-higher-logic .stop1{stop-color:#f15b2b}", ""]);
